import { Center, Loader } from '@mantine/core';
import { useParams } from 'react-router-dom';

import { useGetObjectionResponses } from '../api/getObjectionResponses';
import { ObjectionResponsesTable } from '../components/ObjectionResponsesTable';

export const ObjectionResponsesPage = () => {
  const params = useParams<{ aiId: string }>();
  const aiId = Number(params.aiId);

  const isAiIdValid = Number.isFinite(aiId);
  const { data, isLoading } = useGetObjectionResponses({
    aiId: isAiIdValid ? aiId : 0,
    config: {
      enabled: isAiIdValid,
    },
  });

  if (!Number.isFinite(aiId)) {
    return <div>Invalid AI ID</div>;
  }

  if (isLoading || !data) {
    return (
      <Center>
        <Loader />
      </Center>
    );
  }

  return <ObjectionResponsesTable aiId={aiId} responses={data.responses} />;
};
